var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2936 21.8067C46.4835 22.0072 46.4748 22.3237 46.2743 22.5136L27.4962 40.2916C27.3034 40.4742 27.0015 40.4742 26.8087 40.2916L16.5213 30.552C16.3208 30.3622 16.3121 30.0457 16.502 29.8452L17.9916 28.2718C18.1814 28.0713 18.4979 28.0626 18.6984 28.2525L26.8087 35.9309C27.0015 36.1134 27.3034 36.1134 27.4962 35.9309L44.0972 20.214C44.2977 20.0241 44.6142 20.0328 44.804 20.2333L46.2936 21.8067Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5004,
    cy: 30.5268,
    r: 29.0268,
    stroke: "currentColor",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/CheckCircleIcon.a796cb30bb36f7babd55ddf24d5d7d02.svg";
export { ForwardRef as ReactComponent };